import { observable, computed, action } from "mobx"; // set, toJS
import { Hand } from "./Hand";
import { comm } from "../../comm";
import { store } from "../mainStore";
import { i18n } from '../../i18n';

const statuses = [
	'pre-game',
	'round1',
	'round2',
	'round3',
	'results',
	'resigned',
	'canceled',
	'invalidated'
];

const hands = {
	1:		'high-card'       ,
	2:		'pair'            ,
	3:		'two-pair'        ,
	4:		'three-of-a-kind' ,
	5:		'straight'        ,
	6:		'flush'           ,
	7:		'full-house'      ,
	8:		'four-of-a-kind'  ,
	9:		'five-of-a-kind'  ,
	10:	'six-of-a-kind'   ,
	11:	'straight-flush'  ,
	12:	'royal-flush'
};

export class Match {
	@observable matchId = null;
	@observable round = 0;
	@observable opponent = {
		id: null,
		name: '',
		hasCompletedRolls: false,
		hands: [],
		image: '',
		currentRound: 0
	};
	@observable type = '1v1';
	@observable gameTime = Date.now();
	@observable goals = [];

	@observable handNumber = 1;
	@observable hearts = 2;

	@observable hands = [];

	@observable currentHand = null;
	@observable status = 0;
	@observable state = '';
	@observable userState = '';

	@observable complete = false;

	@observable userHasSeenResolution = false;

	@observable roundCount = 3;

	@observable winAmount;

	@observable fromResume = false;
	@observable viewOnlyMode = false;

	@observable canAcceptChallenge = false;
	@observable isStartHand = false;
	@observable canRollDice = false;
	@observable canApplyFreeroll = false;
	@observable canApplyHandReset = false;
	@observable canKeepHand = false;
	@observable canResignMatch = false;
	@observable canClaimReward = false;

	@observable playerCount = 0;

	@computed get statusText(){
		return statuses[this.status];
	}

	@computed get goal(){
		return this.goals[this.goals.length - 1];
	}

	@observable rounds = [];

	constructor(match, mode, network) {
		if(network){
			this.matchId = match.Id;
			this.status = match.UserCurrentRound;
			this.round = match.UserCurrentRound;
			this.handNumber = match.UserCurrentRound;

			this.canAcceptChallenge = match.CanAcceptChallenge;
			this.isStartHand = match.IsStartHand;
			this.canRollDice = match.CanRollDice;
			this.canApplyFreeroll = match.CanApplyFreeroll;
			this.canApplyHandReset = match.CanApplyHandReset;
			this.canKeepHand = match.CanKeepHand;
			this.canResignMatch = match.CanResignMatch;
			this.canClaimReward = match.CanClaimReward;

			this.playerCount = match.PlayerCount;

			if(match.Opponents.length === 0){
				this.opponent = {
					id: 0,
					name: 'unknown',
					image: '',
					currentRound: 1,
					hands: [],
					level: 0
				}
			} else {
				let opp = match.Opponents[0];
				this.opponent = {
					id: opp.UserId,
					name: opp.DisplayName || opp.Username,
					isBot: opp.IsBot,
					image: opp.ImageUrl,
					botKey: opp.Username,
					currentRound: opp.CurrentRound,
					hands: [],
					level: opp.summary ? opp.summary.Level : 0
				}
				if(this.opponent.isBot === true) {
					this.opponent.name = i18n.t(this.opponent.name);
					this.opponent.image = this.opponent.name !== "" ? '/assets/bots/'+this.opponent.botKey+'.jpg' : '/assets/portrait_blueBot.jpg'
				}
			}

			this.viewOnlyMode = mode === 'view';

			this.rounds = match.Rounds;

			this.roundCount = match.RoundCount;
			this.goals.replace(match.Rounds.map(r => hands[r.TargetHand]));
			var heartsUsed = 0;
			match.UserMatchRounds.forEach((round) => {
				this.hands.push(new Hand(round, true));
				if(round.Rolls.length > 3){
					heartsUsed += round.Rolls.length - 3;
				}
			})
			this.hearts = match.UserFreeRolls - heartsUsed;
			if(match.Opponents.length && match.Opponents[0].MatchRounds){
				match.Opponents[0].MatchRounds.forEach(round => {
					//if(round.State > 2){
						this.opponent.hands.push(new Hand(round, true));
					//}
				});
			}
			this.currentHand = this.hands[this.hands.length - 1];
			this.state = match.State;
			this.userState = match.UserState;
			this.needToAcceptChallenge = match.UserState === 'pe';
			this.type = match.Type;

			//the player is returning for the first hand of a new round and the opponent has results to show and the player is the initiator of the match
			this.shouldShowScorecardFirst = this.hands.length % 3 === 1 && this.opponent.hands.length > 0 && this.hands.length > this.opponent.hands.length
		} else {
			Object.assign(this, match);
		}
	}

	@action useHeart(){
		// this.hearts += -1;
		store.user.hearts += -1; //using Rob's special subtraction technique :)
		this.currentHand.rollsRemaining = 1;
	}
	@action useHandReset(){
		// this.hearts += -1;
		store.user.hearts += -5; //using Rob's special subtraction technique :)
		this.currentHand.rollsRemaining = 3;
	}

	@action start(){
		if(this.status < 1){
			// this.status = 1;
			// this.handNumber = 1;
			// this.rollNumber = 0;
			// this.currentHand = new Hand();
			// this.hands.push(this.currentHand);
		} else {
			console.warn('Attempted to start a game in progress.');
		}
	}

	@action claimReward(){
		return comm.ClaimMatchReward(this.matchId)
		.then((data) => {
			if(data.Payload.LevelProgress && data.Payload.LevelProgress.IsLevel){
				let lvl = data.Payload.LevelProgress;
				console.log(lvl);
				store.user.xpData.updateFromServer(lvl);
			}

			window.store.debug = `
				level ${store.user.level} |
				animateToLevel ${store.user.animateToLevel} |
				xpStart ${store.user.xpStart} |
				xp ${store.user.xp} |
				animateToXp ${store.user.animateToXp} |
				xpNext ${store.user.xpNext} |
				xpIsCurrent ${store.user.xpIsCurrent}
			`;

			this.canClaimReward = false;
			return data;
		});
	}

	@action nextHand(){
		return new Promise((resolve, reject) => {
			var hasOpponentData = this.PollForOpponentData();

			if(store.activeMatch.currentHand.complete){
				hasOpponentData.then(resolve);
			} else {
				comm.CompleteHand(store.activeMatch.matchId, store.activeMatch.currentHand.heldIndexes)
				.then((data) => {
					//if there is a level up reward, add rolls gained.
					if(data.Payload.LevelProgress && data.Payload.LevelProgress.IsLevel){
						let lvl = data.Payload.LevelProgress;
						console.log(lvl);

						store.user.xpData.updateFromServer(lvl);
					}
					window.store.debug = `
					level ${store.user.level} |
					animateToLevel ${store.user.animateToLevel} |
					xpStart ${store.user.xpStart} |
					xp ${store.user.xp} |
					animateToXp ${store.user.animateToXp} |
					xpNext ${store.user.xpNext} |
					xpIsCurrent ${store.user.xpIsCurrent}
					`;

					if(data.Payload.LevelUpReward && data.Payload.LevelUpReward.ConfirmationKey){
						store.user.animateToHearts = store.user.hearts + data.Payload.LevelUpReward.Rewards.roll;
						store.confirmedRewards.push(data.Payload.LevelUpReward.ConfirmationKey);
						comm.ConfirmNotification(data.Payload.LevelUpReward.ConfirmationKey, 0)
						.then(() => {
							hasOpponentData.then(resolve).catch(reject);
						});
					} else {
						hasOpponentData.then(resolve).catch(reject);
					}
				});
			}
		})
		.then(() => {
			return store.updateMatch()
			.then(() => {
				this.currentHand.complete = true;
				this.currentHand = new Hand();
				this.hands.push(this.currentHand);
				this.handNumber++;
				this.status++;
			});
		});
	}

	PollForOpponentData = () => {
		return new Promise((resolve, reject) => {
			(function poll(){
				if(store.activeMatch.handNumber % 3 !== 0){
					resolve();
				} else {
					setTimeout(() => {
						store.updateMatch()
						.then(resolve)
						.catch(reject);
					}, 1000);
				}
			})();
		});
	}

	@action updateFromNetwork(match){
		this.goals.replace(match.Rounds.map(r => hands[r.TargetHand]));

		this.hands.forEach((hand, i) =>
			hand.updateFromNetwork(match.UserMatchRounds[i]));
		this.round = this.goals.length;

		this.canAcceptChallenge = match.CanAcceptChallenge;
		this.canClaimReward = match.CanClaimReward;
		this.isStartHand = match.IsStartHand;
		this.canRollDice = match.CanRollDice;
		this.canApplyFreeroll = match.CanApplyFreeroll;
		this.canApplyHandReset = match.CanApplyHandReset;
		this.canKeepHand = match.CanKeepHand;
		this.canResignMatch = match.CanResignMatch;

		this.playerCount = match.PlayerCount;

		if(match.Opponents.length && match.Opponents[0].MatchRounds){
			let opHands = [];
			match.Opponents[0].MatchRounds.forEach((round) => {
				// if(round.State > 2){
					opHands.push(new Hand(round, true));
				// }
			});
			this.opponent.hands.replace(opHands);
		}
		this.opponent.currentRound = 0;

		if(match.Opponents.length && match.Opponents[0].MatchRounds.length){
			this.opponent.currentRound = match.Opponents[0].MatchRounds.length;
		}

		this.state = match.State;
		this.userState = match.UserState;
		this.type = match.Type;
		this.complete = match.State === 'co';
		// this.hands.forEach((hand, i) => {
		// 	hand.updateFromNetwork(match.UserMatchRounds[i])
		// });
		// console.log(this.goals);
	}

}
